/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Marius Runde
 * Date: 02.06.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Container, Tab, Tabs } from 'external/react-bootstrap';

import { Title } from 'plugin/liferay-widgets-react-web';

import MapConfigDetails from './MapConfigDetails';
import MapConfigPlugins from './MapConfigPlugins';
import MapConfigLayerTree from './MapConfigLayerTree';
import MapConfigLayerOrdering from './MapConfigLayerOrdering';
import MapConfigBaseLayerSelection from './MapConfigBaseLayerSelection';
import { findAndSortLogicalLayers, findLogicalLayersWithoutZIndex } from '../utils/map-config-util';

class MapConfigEditForm extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            activeTabKey: 'tabBaseLayer'
        };
    }

    handleMapConfigChange(mapConfig){
        this.handleChange({
            ...this.props.formData,
            ...mapConfig
        });
    }

    onBoundingBoxChanged(boundingBox){
        this.handleChange({
            ...this.props.formData,
            boundingBox
        });
    }

    handlePluginsChange(plugins){
        this.handleChange({
            ...this.props.formData,
            plugins
        });
    }

    handleLogicalLayerOrderChange(logicalLayers){
        logicalLayers.forEach((ll, idx, arr) => ll.zIndex = arr.length - idx);
        this.handleChange(this.props.formData);
    }

    handleLayerSetsChange(layerSets){
        this.handleChange({
            ...this.props.formData,
            children: layerSets
        });
    }

    handleChange(formData){
        this.props.onChange(formData, this.validate(formData));
    }

    validate(formData){
        let titleValid, descriptionValid, boundingboxValid, defaultBaseLayerValid, baseLayerValid, zIndexesValid;

        if (!(formData.title && formData.title.length > 0)) {
            titleValid = 'Bitte Titel eingeben';
        }

        if ((formData.title && formData.title.length > 0 && !/\S/.test(formData.title))) {
            titleValid = 'Titel darf nicht mit einem Leerzeichen starten!';
        }

        if ((formData.title && formData.title.length > 0) && !(formData.title.length <= 75)) {
            titleValid = 'Titel zu lang. Maximal 75 Zeichen.';
        }

        if ((formData.description && formData.description.length > 0 && !/\S/.test(formData.description))) {
            descriptionValid = 'Beschreibung darf nicht mit einem Leerzeichen starten!';
        }

        if ((formData.description && formData.description.length > 0) && !(formData.description.length <= 3999)) {
            descriptionValid = 'Beschreibung zu lang. Maximal 3999 Zeichen.';
        }

        const bb = formData.boundingBox;
        if (!(bb && bb.latitudeMax > 0 && bb.latitudeMin > 0 && bb.longitudeMax > 0 && bb.longitudeMin > 0)) {
            boundingboxValid = 'Bitte Boundingbox angeben';
        }

        if (!(formData.defaultBaseLayerId && formData.defaultBaseLayerId > 0)) {
            defaultBaseLayerValid = 'Bitte Standard BasisLayer auswählen';
        }

        if (!(formData.baseLayer && formData.baseLayer.length > 0)) {
            baseLayerValid = 'Bitte min. 1 BasisLayer auswählen';
        }

        if (formData.children && formData.children.length > 0) {
            const noZindexLayers = findLogicalLayersWithoutZIndex(formData.children);
            if (noZindexLayers && noZindexLayers.length > 0) {
                zIndexesValid = 'Bitte folgende Layer einsortieren:' + noZindexLayers.reduce((prev, cur) => {
                    return prev += ' ' + cur.title;
                }, '');
            }

        }

        return {
            title: titleValid,
            defaultBaseLayer: defaultBaseLayerValid,
            baseLayer: baseLayerValid,
            zIndexes: zIndexesValid,
            description: descriptionValid,
            boundingBox: boundingboxValid
        };
    }

    handleSelectTab(tabKey){
        this.setState({
            activeTabKey: tabKey
        });
    }

    render(){
        const { formData: mapConfig, formValidation, logicalLayers } = this.props;
        const mapConfigItem = mapConfig && mapConfig.item || mapConfig;

        const logicalLayerItems = findAndSortLogicalLayers(mapConfigItem);

        return (
            <Container className="py-3">
                <Title title="Kartenkonfiguration bearbeiten"/>

                <MapConfigDetails
                    mapConfig={mapConfigItem}
                    onBoundingBoxChanged={this.onBoundingBoxChanged.bind(this)}
                    formValidation={formValidation}
                    onChange={this.handleMapConfigChange.bind(this)}
                />

                <Tabs
                    activeKey={this.state.activeTabKey}
                    onSelect={this.handleSelectTab.bind(this)}
                    id="frb-tabs"
                >
                    <Tab eventKey={'tabBaseLayer'} title="Basislayer *">
                        <MapConfigBaseLayerSelection
                            layers={logicalLayers}
                            mapConfig={mapConfig}
                            formValidation={formValidation}
                            onChange={this.handleMapConfigChange.bind(this)}
                        />

                    </Tab>

                    <Tab eventKey={'tabLayerTree'} title="Layer-Gruppierung">
                        <MapConfigLayerTree
                            layerSets={mapConfigItem.children}
                            logicalLayers={logicalLayers}
                            formValidation={formValidation}
                            onChange={this.handleLayerSetsChange.bind(this)}
                        />
                    </Tab>

                    <Tab eventKey={'tabZIndex'} title="Layer-Reihenfolge">
                        <MapConfigLayerOrdering
                            logicalLayers={logicalLayerItems && logicalLayerItems.reverse()}
                            formValidation={formValidation}
                            onChange={this.handleLogicalLayerOrderChange.bind(this)}
                        />
                    </Tab>

                    <Tab eventKey={'tabPlugins'} title="Plugins">
                        <MapConfigPlugins
                            plugins={mapConfigItem.plugins}
                            onChange={this.handlePluginsChange.bind(this)}
                        />
                    </Tab>
                </Tabs>
            </Container>
        );
    }
}

MapConfigEditForm.propTypes = {
    onChange: PropTypes.func,
    formData: PropTypes.object,
    formValidation: PropTypes.object,
    logicalLayers: PropTypes.object
};

export default MapConfigEditForm;



// WEBPACK FOOTER //
// ./js/components/MapConfigEditForm.jsx